import { Stack, Typography } from '@mui/material';
import { Card } from 'components/Card';
import { InfoMessage } from 'components/InfoMessage';
import React, { ReactNode } from 'react';
import { AnalyticsAccountChecklist, AnalyticsAccountChecklistItem } from 'types';
import { CustomCheckListAccordion } from './CustomCheckListAccordion';

export const GA4CheckList = ({ checkList }: { checkList: AnalyticsAccountChecklist }) => {
  return checkList.map(({ title, description, Content, variant, accordion, additionalError }, index) => (
    <Card variant={variant} key={title} sx={{ p: 0 }}>
      <Stack gap={4} p={5}>
        <Typography variant="subtitle1">{title}</Typography>
        {additionalError && (
          <InfoMessage
            fullWidth
            variant="error"
            title={additionalError.title}
            message={<Typography>{additionalError.description}</Typography>}
          />
        )}
        {description && <Typography sx={{ whiteSpace: 'pre-wrap' }}>{description}</Typography>}
        <Content />
      </Stack>
      {accordion && <CustomCheckListAccordion Content={accordion.Content} index={index} />}
    </Card>
  ));
};

export const GA4CheckListItem = ({
  checkListItem,
  children,
}: {
  checkListItem: AnalyticsAccountChecklistItem;
  children: ReactNode;
}) => {
  const { title, description, Content, variant, accordion, additionalError } = checkListItem;

  return (
    <Card variant={variant} key={title} sx={{ p: 0 }}>
      <Stack gap={4} p={5}>
        <Typography variant="subtitle1">{title}</Typography>
        {additionalError && (
          <InfoMessage
            fullWidth
            variant="error"
            title={additionalError.title}
            message={<Typography>{additionalError.description}</Typography>}
          />
        )}
        {description && <Typography sx={{ whiteSpace: 'pre-wrap' }}>{description}</Typography>}
        <Content />
        {children}
      </Stack>
      {accordion && <CustomCheckListAccordion Content={accordion.Content} index={0} />}
    </Card>
  );
};
